import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import styled from "styled-components";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import CenteredColumn from "./layout/CenteredColumn";

import LandingPage from "./pages/LandingPage";
import VehicleInfoPage from "./pages/VehicleInfoPage";
import InterestedVehiclePage from './pages/InterestedVehiclePage';
import ContactPage from "./pages/ContactPage";
import ReportPage from "./pages/ReportPage";
import ErrorPage from "./pages/ErrorPage";
import NoValueReportPage from "./pages/NoValueReportPage";
import AppFooter from "./components/AppFooter";

import "./route-transitions.css";
import useAccountSettings from "./hooks/useAccountSettings";
import './utils/ga-gmt-iframe';

const TransitionContainer = styled(TransitionGroup)`
  position: relative;
  background-color: white;
`;

const withFooter = Component => {
  return ({ children, ...props }) => {
    const { params } = props.match;
    const { accountId } = params;
    const [{ removeBranding }] = useAccountSettings({ accountId });
    return (
      <Component {...props}>
        {children}
        <AppFooter removeBranding={removeBranding} />
      </Component>
    );
  };
};

function App() {
  return (
    <CenteredColumn>
      <Route
        render={({ location }) => (
          <TransitionContainer>
            <CSSTransition key={location.key} classNames="fade" timeout={300}>
              <Switch location={location}>
                <Route
                  exact
                  path="/:accountId"
                  component={withFooter(LandingPage)}
                />
                <Route
                  exact
                  path="/:accountId/:yearId/:makeId/:modelId/:trimId"
                  component={withFooter(VehicleInfoPage)}
                />
                <Route
                  exact
                  path="/:accountId/:yearId/:makeId/:modelId/:trimId/interest"
                  component={withFooter(InterestedVehiclePage)}
                />
                <Route
                  exact
                  path="/:accountId/:yearId/:makeId/:modelId/:trimId/contact"
                  component={withFooter(ContactPage)}
                />
                <Route
                  exact
                  path="/:accountId/:yearId/:makeId/:modelId/:trimId/report"
                  component={withFooter(ReportPage)}
                />
                <Route
                  exact
                  path="/:accountId/:yearId/:makeId/:modelId/:trimId/no-report"
                  component={withFooter(NoValueReportPage)}
                />
                <Route
                  exact
                  path="/:accountId/no-report"
                  component={withFooter(NoValueReportPage)}
                />
                <Route
                  path="/:accountId/error"
                  component={withFooter(ErrorPage)}
                />
                <Redirect
                  exact="/"
                  from="/"
                  to="/7763e081062849449bf55af3e42ce66d"
                />
              </Switch>
            </CSSTransition>
          </TransitionContainer>
        )}
      />
    </CenteredColumn>
  );
}

export default App;
